import { render, staticRenderFns } from "./DuplicateVacancy.vue?vue&type=template&id=4160a762&scoped=true"
import script from "./DuplicateVacancy.vue?vue&type=script&lang=js"
export * from "./DuplicateVacancy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4160a762",
  null
  
)

export default component.exports